(function($){
$(document).ready(function(){

	const $materialZidarie = $('#material-zidarie');
	const $selectedDimensionEl = $('#dimensiune-bca');
	const $resultNrPaleti = $('#result-nr-paleti');
	const $izomineralFields = $('.izomineral-field');
	const $resultNrPaletiIzomineral = $('#result-nr-paleti-izomineral');
	const $resultNrSaci = $('#result-nr-saci');
	const $resultNrSaciIzomineral = $('#result-nr-saci-v9');
	const $resultSuprafataInzidita = $('#result-suprafata-inzidita');
	const $resultBlocuriPePalet = $('#result-blocuri-pe-palet');
	const $resultRezistentaTermicaZidarie = $('#result-rezistenta-termica-zidarie');
	const $resultRezistentaTermicaIzomineral = $('#result-rezistenta-termica-izomineral');
	const $resultRezistentaTermicaTotala = $('#result-rezistenta-termica-totala');
	const $resultSuprafataIzomineral = $('#result-suprafata-izomineral');
	const $resultGrosimeIzomineral = $('#result-grosime-izomineral');

	const $resultCostZidarie = $('#result-cost-zidarie');
	const $resultCostZidarieMp = $('#result-cost-zidarie-mp');
	const $resultCostIzomineral = $('#result-cost-izomineral');
	const $resultCostIzomineralMp = $('#result-cost-izomineral-mp');
	const $resultCostTotal = $('#result-cost-total');
	const $resultCostTotalMp = $('#result-cost-total-mp');

	const $resultRedHouse = $('.result-red-house');
	const $resultGreenHouse = $('.result-green-house');
	const $resultPromotionBCA = $('#result-promotion-bca');
	const $resultPromotionIzomineral = $('#result-promotion-izomineral');

	const SACI_M5_PER_PALET = 3;
	const bcaProfiles = window.evxCalculatorBca || {};

	function formatDecimal(value, maxDecimals) {
		maxDecimals = maxDecimals === undefined ? 2 : maxDecimals;
		const num = Number(value);

		if (!isFinite(num)) {
			return '0';
		}

		return parseFloat(num.toFixed(maxDecimals)).toString();
	}

	let rezTermicaZidarie = 0;
	let rezTermicaIzomineral = 0;
	let rezTermicaTotala = 0;
	let rezCostZidarie = 0;
	let rezCostZidarieMp = 0;
	let rezCostIzomineral = 0;
	let rezCostIzomineralMp = 0;
	let rezCostTotal = 0;
	let rezCostTotalMp = 0;

	let totalPaletiPrimar = 0;
	let paletiNr = 0;
	let nrPaletiIzomineral = 0;
	let nrSaciIzomineral = 0;
	let suprafataIzomineral = 0;

	function getSelectedProfileKey() {
		return $materialZidarie.find('option:selected').attr('data-bca-profile') || 'constanta';
	}

	function getActiveBcaSorts() {
		const profileKey = getSelectedProfileKey();
		const profile = bcaProfiles[profileKey];

		if (!profile) {
			return null;
		}

		return {
			sorts: profile.sorts,
			blocks: profile.blocks,
			grosimePalet: profile.grosime_palet,
			grosimeAditional: profile.grosime_aditional,
			nrBlocPaleti: profile.nr_bloc_paleti,
			tipSpecific: profile.tip_specific,
			blockFaceArea: profile.block_face_area,
			completion150Label: profile.completion_150_label,
			completion100Label: profile.completion_100_label,
		};
	}

	function getDimensionIndex() {
		return parseInt($selectedDimensionEl.val(), 10) || 0;
	}

	function filterDimensionOptions() {
		const profileKey = getSelectedProfileKey();
		let firstVisible = null;

		$selectedDimensionEl.find('option').each(function() {
			const $option = $(this);
			const matches = $option.attr('data-bca-profile') === profileKey;

			$option.prop('hidden', !matches);
			$option.prop('disabled', !matches);

			if (matches && null === firstVisible) {
				firstVisible = $option;
			}
		});

		const $selected = $selectedDimensionEl.find('option:selected');
		if (($selected.prop('hidden') || $selected.prop('disabled')) && firstVisible) {
			firstVisible.prop('selected', true);
		}
	}

	function recalculateAll() {
		filterDimensionOptions();
		calcBCA();
		calcRT();
		calcRTIzomineral();
		calcRTTotal();
		calcCostZidarie();
		calcCostIzomineral();
		calcCostTotal();
	}

	$materialZidarie.on('change', recalculateAll);

	$('#dimensiune-bca, #suprafata-de-construit, #grosime-izomineral, #suprafata-de-izolat').on('change keyup', recalculateAll);

	function calcBCA() {
		const bcaSorts = getActiveBcaSorts();
		const dimensionIndex = getDimensionIndex();
		const wallSurfaceVal = parseInt($('#suprafata-de-construit').val(), 10);

		if (!bcaSorts || isNaN(wallSurfaceVal)) {
			paletiNr = 0;
			$resultNrPaleti.text(0);
			$resultNrSaci.text(0);
			$('#s_zidita_main').hide();
			$('#s_zidita_sec').hide();
			return;
		}

		paletiNr = (wallSurfaceVal / bcaSorts.blockFaceArea / bcaSorts.blocks[dimensionIndex]).toString();
		paletiNr = parseInt(paletiNr.indexOf('.') === -1 ? parseInt(paletiNr, 10) : parseInt(paletiNr.substr(0, paletiNr.indexOf('.')), 10) + 1, 10);

		const resultForTotalPaleti = paletiNr;
		const mortarResult = paletiNr * SACI_M5_PER_PALET;

		const sZiditaResult = bcaSorts.grosimeAditional[dimensionIndex] === 0
			? formatDecimal(bcaSorts.grosimePalet[dimensionIndex])
			: formatDecimal(bcaSorts.grosimePalet[dimensionIndex]) + ' + ' + formatDecimal(bcaSorts.grosimeAditional[dimensionIndex]);
		const nrBlocuriResult = bcaSorts.nrBlocPaleti[dimensionIndex];

		totalPaletiPrimar = parseInt(resultForTotalPaleti, 10) * bcaSorts.grosimePalet[dimensionIndex];
		const totalPaletiSec = parseInt(resultForTotalPaleti, 10) * bcaSorts.grosimeAditional[dimensionIndex];

		$resultNrPaleti.text(paletiNr);
		$resultNrSaci.text(mortarResult);
		$resultSuprafataInzidita.html(sZiditaResult);
		$resultBlocuriPePalet.text(nrBlocuriResult);

		$('#indice_label').show();
		$('#s_zidita_t').html('Suprafata zidita cu ' + paletiNr + ' paleti:');
		$('#s_zidita_main').show().html(formatDecimal(totalPaletiPrimar) + ' m<sup>2</sup> cu grosime de ' + bcaSorts.sorts[dimensionIndex] + 'mm');

		if (bcaSorts.tipSpecific[dimensionIndex] === 1) {
			$('#s_zidita_sec').show();
			$('#indice_label').show();
			$('#s_zidita_sec').html(formatDecimal(totalPaletiSec) + ' m<sup>2</sup> cu grosime de 150mm');
			$('#indice_label').html('Paletul include 20 blocuri BCA ' + bcaSorts.completion150Label);
		} else if (bcaSorts.tipSpecific[dimensionIndex] === 2) {
			$('#s_zidita_sec').show();
			$('#indice_label').show();
			$('#s_zidita_sec').html(formatDecimal(totalPaletiSec) + ' m<sup>2</sup> cu grosime de 100mm');
			$('#indice_label').html('Paletul include 10 blocuri BCA ' + bcaSorts.completion100Label);
		} else {
			$('#indice_label').hide();
			$('#s_zidita_sec').hide();
		}
	}

	function calcRT() {
		const bcaSorts = getActiveBcaSorts();
		const dimensionIndex = getDimensionIndex();

		if (!bcaSorts) {
			return;
		}

		rezTermicaZidarie = 1 / 24 + 1 / 8 + bcaSorts.sorts[dimensionIndex] / 1000 / parseFloat($materialZidarie.find('option:selected').data('conductivitate-termica'));
		rezTermicaZidarie = Math.round(rezTermicaZidarie * 100) / 100;
		$resultRezistentaTermicaZidarie.html(rezTermicaZidarie + ' m<sup>2</sup>K/W');
	}

	function calcRTIzomineral() {
		rezTermicaIzomineral = parseFloat($('#grosime-izomineral option:selected').data('rez-transfer-termic'));
		$resultRezistentaTermicaIzomineral.html(formatDecimal(rezTermicaIzomineral) + ' m<sup>2</sup>K/W');
	}

	function calcRTTotal() {
		rezTermicaTotala = rezTermicaZidarie + rezTermicaIzomineral;
		rezTermicaTotala = Math.round(rezTermicaTotala * 100) / 100;

		if (rezTermicaTotala < 4) {
			$resultRezistentaTermicaTotala.removeClass('text-green').addClass('text-primary');
			$resultRedHouse.addClass('d-flex').removeClass('d-none');
			$resultGreenHouse.removeClass('d-flex').addClass('d-none');
		} else {
			$resultRezistentaTermicaTotala.removeClass('text-primary').addClass('text-green');
			$resultRedHouse.removeClass('d-flex').addClass('d-none');
			$resultGreenHouse.addClass('d-flex').removeClass('d-none');
		}

		$resultRezistentaTermicaTotala.html(rezTermicaTotala + ' m<sup>2</sup>K/W');
	}

	function calcCostZidarie() {
		rezCostZidarie = parseInt(paletiNr * parseFloat($materialZidarie.find('option:selected').data('pret-per-palet')), 10);
		rezCostZidarieMp = Math.floor(rezCostZidarie / totalPaletiPrimar * 100) / 100;

		if (rezCostZidarie > 0) {
			$resultPromotionBCA.addClass('d-flex').removeClass('d-none');
		} else {
			$resultPromotionBCA.addClass('d-none').removeClass('d-flex');
		}

		$resultCostZidarie.text(rezCostZidarie);
		$resultCostZidarieMp.text(isNaN(rezCostZidarieMp) ? 0 : formatDecimal(rezCostZidarieMp));
	}

	function calcCostIzomineral() {
		const suprafataIzolatie = parseInt($('#suprafata-de-izolat').val(), 10);
		const grosimeIzomineral = parseInt($('#grosime-izomineral').val(), 10);
		const mpIzolatiePerPalet = parseFloat($('#grosime-izomineral option:selected').data('mp-per-palet'));
		const pretIzolatiePerMp = parseFloat($('#grosime-izomineral option:selected').data('pret-per-palet'));
		const saciPerPalet = parseInt($('#grosime-izomineral option:selected').data('saci-per-palet'), 10);

		if (
			!grosimeIzomineral ||
			isNaN(suprafataIzolatie) ||
			suprafataIzolatie <= 0 ||
			!mpIzolatiePerPalet ||
			!isFinite(mpIzolatiePerPalet)
		) {
			nrPaletiIzomineral = 0;
			nrSaciIzomineral = 0;
			suprafataIzomineral = 0;
			rezCostIzomineral = 0;
			rezCostIzomineralMp = 0;
		} else {
			nrPaletiIzomineral = Math.ceil(suprafataIzolatie / mpIzolatiePerPalet);
			nrSaciIzomineral = nrPaletiIzomineral * (isNaN(saciPerPalet) ? 0 : saciPerPalet);
			suprafataIzomineral = nrPaletiIzomineral * mpIzolatiePerPalet;
			rezCostIzomineral = parseInt(nrPaletiIzomineral * pretIzolatiePerMp, 10);
			rezCostIzomineralMp = Math.floor(rezCostIzomineral / suprafataIzomineral * 100) / 100;
		}

		if (nrPaletiIzomineral > 0 && isFinite(nrPaletiIzomineral)) {
			$izomineralFields.addClass('d-flex').removeClass('d-none');
		} else {
			$izomineralFields.addClass('d-none').removeClass('d-flex');
		}

		if (rezCostIzomineral > 0 && isFinite(rezCostIzomineral)) {
			$resultPromotionIzomineral.addClass('d-flex').removeClass('d-none');
		} else {
			$resultPromotionIzomineral.addClass('d-none').removeClass('d-flex');
		}

		$resultNrPaletiIzomineral.text(nrPaletiIzomineral);
		$resultNrSaciIzomineral.text(nrSaciIzomineral);
		$resultSuprafataIzomineral.text(formatDecimal(suprafataIzomineral));
		$resultGrosimeIzomineral.text(parseInt($('#grosime-izomineral option:selected').text(), 10));
		$resultCostIzomineral.text(isNaN(rezCostIzomineral) ? 0 : rezCostIzomineral);
		$resultCostIzomineralMp.text(isNaN(rezCostIzomineralMp) ? 0 : formatDecimal(rezCostIzomineralMp));
	}

	function calcCostTotal() {
		const costZidarie = isFinite(rezCostZidarie) ? rezCostZidarie : 0;
		const costIzomineral = isFinite(rezCostIzomineral) ? rezCostIzomineral : 0;
		const costZidarieMp = isFinite(rezCostZidarieMp) ? rezCostZidarieMp : 0;
		const costIzomineralMp = isFinite(rezCostIzomineralMp) ? rezCostIzomineralMp : 0;

		rezCostTotal = costZidarie + costIzomineral;
		rezCostTotalMp = Math.floor((costZidarieMp + costIzomineralMp) * 100) / 100;

		$resultCostTotal.text(rezCostTotal);
		$resultCostTotalMp.text(formatDecimal(rezCostTotalMp));
	}

	recalculateAll();

});
})(jQuery);
